import { Navigate, useSearchParams } from "react-router-dom";
import { FallingLines } from "react-loader-spinner";
import { useOnboardingVariant } from "@/hooks/useOnboardingVariant";
import OnboardingVariantA from "@/components/onboarding/OnboardingVariantA";
import OnboardingVariantB from "@/components/onboarding/OnboardingVariantB";

export default function Onboarding() {
  const { variant, isLoading } = useOnboardingVariant();
  const [search] = useSearchParams();

  // Handle placeRef (existing logic)
  const placeRefSearch = search.get("placeRef");
  if (placeRefSearch) {
    window.localStorage.setItem("placeRef", placeRefSearch);
    window.localStorage.setItem("placeRefTimestamp", Date.now().toString());
  }

  // Handle ref redirect (existing logic)
  const ref = search.get("ref");
  if (ref) {
    return <Navigate to="/login" />;
  }

  // Loading state while fetching variant
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <FallingLines visible={true} height="200" width="200" color="#ff5c5c" />
      </div>
    );
  }

  // Render appropriate variant
  return variant === "A" ? <OnboardingVariantA /> : <OnboardingVariantB />;
}
